import { flattenObject } from '@utils/flatten';
import { QuotationItemType } from 'models/SupplementType';

/**
 *  item data를 받아 description 형태의 string으로 return 하는 함수
 */
export const parseQuotationItemDescription = (item: QuotationItemType) => {
  if (item.description) return item.description;

  // data depth 줄이기
  const parseItemData = flattenObject(item);

  const commonOptions = ['product_type', 'code', 'category', 'maerial', 'material_grade', 'type1', 'type2'];

  const productType = item.product?.product_type;
  const category = item.product?.category;

  const isLength = useIsLength(productType, category);

  let options: string[] = [];

  if (productType === 'PIPE') {
    options = [...commonOptions, 'thickness1', 'thickness2', 'size1', 'end1', 'coating'];
  }
  if (productType === 'VALVE') {
    options = [
      ...commonOptions,
      'pressure_rating',
      'end1',
      'bonnet_type',
      'size1',
      'size2',
      'bore',
      'stem',
      'seat',
      'operation_type',
      'trim_no',
      'disc',
      'plug',
    ];
  }
  if (productType === 'FLANGE') {
    options = [...commonOptions, 'end1', 'coating', 'size1', 'size2', 'pressure_rating', 'thickness1', 'thickness2'];
  }

  if (productType === 'FITTING') {
    options = [
      ...commonOptions,
      'type3',
      'end1',
      'end2',
      'coating',
      'size1',
      'size2',
      'pressure_rating',
      'thickness1',
      'thickness2',
    ];
  }

  if (isLength) {
    options.push('length');
  }

  const validOptions = options.filter((option) => !!parseItemData[option]);

  return `${validOptions.map((option) => parseItemData[option]).join(' | ')}${isLength ? 'mm' : ''}`;
};

export const useIsLength = (productType: string, category: string) => {
  return (
    productType === 'PIPE' ||
    (productType === 'FLANGE' &&
      (category === 'LONG WELDING NECK' || category === 'FLANGEOLET' || category === 'NIPPLE'))
  );
};
